import React from 'react';
import { FormattedMessage } from 'react-intl';

export const WeekData = [
  {
    id: 'monday',
    value: 1,
    label: <FormattedMessage id="hosting.week_data.monday_short" defaultMessage="M"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.monday" defaultMessage="Monday"/>
  },
  {
    id: 'tuesday',
    value: 2,
    label: <FormattedMessage id="hosting.week_data.tuesday_short" defaultMessage="Tu"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.tuesday" defaultMessage="Tuesday"/>
  },
  {
    id: 'wednesday',
    value: 3,
    label: <FormattedMessage id="hosting.week_data.wednesday_short" defaultMessage="W"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.wednesday" defaultMessage="Wednesday"/>
  },
  {
    id: 'thursday',
    value: 4,
    label: <FormattedMessage id="hosting.week_data.thursday_short" defaultMessage="Th"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.thursday" defaultMessage="Thursday"/>
  },
  {
    id: 'friday',
    value: 5,
    label: <FormattedMessage id="hosting.week_data.friday_short" defaultMessage="F"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.friday" defaultMessage="Friday"/>
  },
  {
    id: 'saturday',
    value: 6,
    label: <FormattedMessage id="hosting.week_data.saturday_short" defaultMessage="Sa"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.saturday" defaultMessage="Saturday"/>
  },
  {
    id: 'sunday',
    value: 7,
    label: <FormattedMessage id="hosting.week_data.sunday_short" defaultMessage="Su"/>,
    fullLabel: <FormattedMessage id="hosting.week_data.sunday" defaultMessage="Sunday"/>
  }
];
